import React from "react";
import { useNavigate } from "react-router-dom";
import formBackgrounImg from "../../Img/service-img-bg.jpg";
import puzzleParking from '../../Img/puzzle-parking.jpg'
import puzzlePitParking from '../../Img/puzzle-pit-parking.jpg'
import fourLevelParking from '../../Img/4-level-parking.jpg'
import triLevelParking from '../../Img/tri-parking.jpg'
import dualParking from '../../Img/dual-parking.jpg'
import towerParking from '../../Img/tower-parking.jpg'

const services = [
  {
    title: "Puzzle Parking",
    path: "/services/puzzle-parking",
    image: puzzleParking,
    description: "Efficient vertical and horizontal car shifting for compact spaces.",
  },
  {
    title: "Puzzle Pit Parking",
    path: "/services/puzzle-pit-parking",
    image: puzzlePitParking,
    description: "Underground solution with stacked puzzle layers for high-density zones.",
  },
  {
    title: "4 Level Pit Parking",
    path: "/services/4-level-pit-parking",
    image: fourLevelParking,
    description: "Multi-level underground system offering high vehicle capacity.",
  },
  {
    title: "3 Level Parking",
    path: "/services/3-level-parking",
    image: triLevelParking,
    description: "Above-ground triple-deck parking optimized for medium traffic.",
  },
  {
    title: "3 Level Pit Parking",
    path: "/services/3-level-pit-parking",
    image: formBackgrounImg,
    description: "A hybrid underground parking structure with triple-stack flexibility.",
  },
  {
    title: "2 Level Parking",
    path: "/services/2-level-parking",
    image: dualParking,
    description: "Simple two-tier design for compact or residential use.",
  },
  {
    title: "2 Level Pit Parking",
    path: "/services/2-level-pit-parking",
    image: formBackgrounImg,
    description: "Underground twin-deck system with smooth vertical access.",
  },
  {
    title: "Tower Parking",
    path: "/services/tower-parking",
    image: towerParking,
    description: "Smart vertical system using minimum footprint and max capacity.",
  },
  {
    title: "Rotary Parking",
    path: "/services/rotary-parking",
    image: formBackgrounImg,
    description: "Ferris-wheel style rotary parking ideal for narrow urban spots.",
  },
];

const OurServices = () => {
  const navigate = useNavigate();

  return (
    <section className="lt-service-grid-section">
      <h2 className="lt-service-grid-heading">Our Parking Solutions</h2>
      <div className="lt-service-grid">
        {services.map((service, idx) => (
          <div className="lt-service-card" key={idx}>
            <img src={service.image} alt={service.title} className="lt-service-image" />
            <div className="lt-service-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <button className="lt-know-more" onClick={() => navigate(service.path)}>
                Know More
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurServices;
